import React from 'react';
import styles from './emptySchedule.module.scss';
import { ReactComponent as CompletedEmpty } from '../../static/icon-completed-empty.svg';
import { ReactComponent as UpcomingEmpty } from '../../static/icon-upcoming-empty.svg';

interface EmptyScheduleProps {
  title: string;
  copy: string;
  type: string;
}

const EmptySchedule: React.FC<EmptyScheduleProps> = ({ type, title, copy }) => {
  return (
    <div className={styles.empty}>
      {type === 'upcoming' ? <UpcomingEmpty /> : <CompletedEmpty />}
      <h4>{title}</h4>
      <p>{copy}</p>
    </div>
  );
};

export default EmptySchedule;
